/* tslint:disable */

declare var Object: any;
export interface SharedLoginLogInterface {
  "Phone"?: string;
  "Email"?: string;
  "FirstName"?: string;
  "LastName"?: string;
  "id"?: number;
}

export class SharedLoginLog implements SharedLoginLogInterface {
  "Phone": string;
  "Email": string;
  "FirstName": string;
  "LastName": string;
  "id": number;
  constructor(data?: SharedLoginLogInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SharedLoginLog`.
   */
  public static getModelName() {
    return "SharedLoginLog";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SharedLoginLog for dynamic purposes.
  **/
  public static factory(data: SharedLoginLogInterface): SharedLoginLog{
    return new SharedLoginLog(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SharedLoginLog',
      plural: 'SharedLoginLogs',
      path: 'SharedLoginLogs',
      idName: 'id',
      properties: {
        "Phone": {
          name: 'Phone',
          type: 'string'
        },
        "Email": {
          name: 'Email',
          type: 'string'
        },
        "FirstName": {
          name: 'FirstName',
          type: 'string'
        },
        "LastName": {
          name: 'LastName',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}
